<template>
  <router-view />
</template>

<script setup>
</script>

<style>
/* 全局样式重置，确保全屏无白边 */
body, html {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  overflow: hidden; /* 防止 body 出现滚动条 */
}

#app {
  width: 100%;
  height: 100%;
}
</style>